import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Helmet } from 'react-helmet';
import qs from 'qs';

import Layout from 'components/common/Layout';
import SignUpEmailConfirm from 'components/account/SignUpEmailConfirm';
import AccountNavigation from 'components/account/AccountNavigation';
import AccountLogo from 'components/account/AccountLogo';

import { appTitle, titleSeparator } from 'config/helmetSettings';
import tidioSrc from 'config/tidioSrc';

import { accountSignUpEmailCheck } from 'redux/modules/account';

class AccountLogin extends Component {
  constructor(props) {
    super(props);

    this.state = {
      loading: 1,
      email: null,
      phone: null,
      error: !qs.parse(this.props.location.search.slice(1)).check_token
        ? 'No reload email token provided in URL' : null,
      autoRedirectCountdown: 100,
    };

    this.onSubmit = this.onSubmit.bind(this);
  }

  componentDidMount() {
    const { actions } = this.props;
    const Token = qs.parse(this.props.location.search.slice(1)).check_token;
    const htmlEl = document.querySelector('html');
    htmlEl.classList.add('page-with-tidio');
    if (Token) {
      new Promise((resolve, reject) => {
        actions.accountSignUpEmailCheck({
          values: { Token },
          resolve,
          reject,
        });
      }).then((res) => {
          this.setState({
            loading: 0,
            email: res.data.email,
            phone: res.data.phone,
          });
          this.onStartAutoRedirectCountdown();
        },
        (err) => {
          this.setState({
            loading: 0,
            error: err.error,
          });
          this.onStartAutoRedirectCountdown();
        });
    }
  }

  componentWillUnmount() {
    const htmlEl = document.querySelector('html');
    htmlEl.classList.remove('page-with-tidio');
  }

  onStartAutoRedirectCountdown() {
    this.autoRedirectCountdownInterval = setInterval(() => {
      const { autoRedirectCountdown } = this.state;
      if (autoRedirectCountdown === 1) {
        this.onSubmit();
        clearInterval(this.autoRedirectCountdownInterval);
      } else {
        this.setState({ autoRedirectCountdown: autoRedirectCountdown - 1 });
      }
    }, 50);
  }

  onSubmit() {
    const { history } = this.props;
    const { email, phone } = this.state;
    history.push({
      pathname: '/account/sign-up-phone-confirm',
      state: {
        phone,
        email,
      },
    });
  }

  render() {
    const { recoverOrder, record } = this.props;
    const { error, loading, autoRedirectCountdown } = this.state;

    return (
      <Layout variant="account-login">
        <Helmet>
          <title>
            {appTitle} {titleSeparator} Email Confirmation
          </title>
          <script src={tidioSrc} async />
        </Helmet>
        <AccountLogo />
        <SignUpEmailConfirm
          error={error}
          loading={loading}
          autoRedirectCountdown={autoRedirectCountdown}
          onSubmit={this.onSubmit}
        />
        <AccountNavigation />
      </Layout>
    );
  }
}

AccountLogin.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  recoverOrder: PropTypes.object,
  record: PropTypes.arrayOf(PropTypes.shape({
    pathname: PropTypes.string,
  })).isRequired,
  actions: PropTypes.shape({
    accountSignUpEmailCheck: PropTypes.func.isRequired,
  }).isRequired,
  history: PropTypes.shape({
    replace: PropTypes.func.isRequired,
  }).isRequired,
};

AccountLogin.defaultProps = {
  recoverOrder: {},
};

const mapStateToProps = store => ({
  recoverOrder: store.recoverOrder,
  record: store.routerParams.record,
});

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators({ accountSignUpEmailCheck }, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(AccountLogin);



// WEBPACK FOOTER //
// ./src/pages/account/AccountSignUpEmailConfirm.js